import { StyledAuth } from "./style";
import { MyButton, MyText } from "../../components";
import { Col, Flex, Form, Input, Row, message, Grid } from "antd";
import { LogoIcon } from "../../assets";
import { useMemo, useState, useEffect, useCallback } from "react";
import { KeyOutlined } from "@ant-design/icons";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { LANG_KEY } from "../../utils/constants/language";
import { MySegmented } from "../../components";
import { StyledCheckbox, StyledLink } from './style';
import { RegistrationSteps } from "../../components/common/MySteps";
import { useDispatch, useSelector } from 'react-redux';
import {useTranslation} from "react-i18next";
import {fetchRegister,fetchAuth, ROUTE_PATH, selectStore, fetchResendCodeAction, fetchConfirmPasswordAction } from "../../utils/"
import { useLang } from "../../utils/context/lang";
import {Cookies} from "react-cookie";
import { COOKIE_KEY } from "../../utils/";
import { useEmbeddedLink } from "../../utils/context/embed";
import { useEmbeddedNavigate } from "../../utils/context/embed";
const FORM_NAME = {
  email: 'email',
  phone: 'phone',
};

export const RegisterVerification = () => {
  const {profile: {registerData: registerDataState, userProfile: userProfileState, confirmPassword: confirmPasswordState}} = useSelector(selectStore)

  const [form] = Form.useForm();
  const [currentStep, setCurrentStep] = useState(1);
  const [verificationCode, setVerificationCode] = useState('');
  const [isConsentChecked, setIsConsentChecked] = useState(false);
  const [isAgreementChecked, setIsAgreementChecked] = useState(false);
  const [isPrivacyChecked, setIsPrivacyChecked] = useState(false);
  const [errors, setErrors] = useState<any>([]);
  const [timer, setTimer] = useState(59);
  const [canResend, setCanResend] = useState(false); 
  const [isExiting, setIsExiting] = useState(false);
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  const dispatch = useDispatch();
  const cookies = new Cookies()
  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const location = useLocation();
  const {t} = useTranslation("common")
  const { username } = location.state || {};
  const {handleChangeLang, lang} = useLang()
  const embeddedLink = useEmbeddedLink();

  useEffect(() => {
    let interval = null;
    if (!canResend && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setCanResend(true);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timer, canResend]);

  // const handleResendCode = () => {
  //   const confirmUserData = {username: registerDataState?.data?.username}
  //   resendCodeUser(confirmUserData)
  //   setCanResend(false);
  //   setTimer(59);
  // };

  const handleResendCode = () => {
    dispatch(fetchResendCodeAction({ username: registerDataState?.data?.username }));
    setCanResend(false);
    setTimer(59);
  };

  const handleChangeLangSelect = useCallback((value: any) => {
      handleChangeLang(value)
    }, [])
  

    // const handleUserConfirmation = () => {
    //   form.validateFields().then(() => {
    //     confirmUser({
    //       username: registerDataState?.data?.username,
    //       confirm_token: verificationCode
    //     })
    //       .then((response) => {
    //         if (response.status === "success") {
    //           setIsExiting(true);
    //           setTimeout(() => {
    //             setCurrentStep(currentStep + 1);
    //             embeddedNavigate("/auth");
    //             // navigate("/register/confirm");
    //           }, 400);
    //         } else {
    //           // message.error(response?.message || t("registrationError"));
    //         }
    //       })
    //       .catch((error) => {
    //         const errorData = error?.response?.data;
    //         setErrors(errorData?.errors || []);
    //       });
    //   });
    // };

    const handleUserConfirmation = async () => {
  try {
    await form.validateFields();

    const response: any = await dispatch(
      fetchConfirmPasswordAction({
        username: registerDataState?.data?.username,
        confirm_token: verificationCode
      })
    );
    
    if (!confirmPasswordState?.success) return;

    const res: any = await dispatch(
      fetchAuth({
        username: registerDataState?.data?.username,
        password: registerDataState?.data?.password
      })
    );

    if (res?.status === "success") { embeddedNavigate("/");
    } else {
      setErrors([res?.message || "Ошибка авторизации"]);
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    setErrors(errorData?.errors || []);
  }
};

useEffect(() => {
    if (userProfileState?.success && token) {
      embeddedNavigate('/');
    } else if (!userProfileState?.success && !userProfileState?.loading && userProfileState?.failed) {
      // message.error(t("loginError"));
    }
  }, [userProfileState, token]);

  const isButtonEnabled = () => {
    return (
      verificationCode.trim() !== '' &&
      isConsentChecked &&
      isAgreementChecked 
      // &&
      // isPrivacyChecked
    );
  };

  return (
    <StyledAuth className={isExiting ? "fade-out" : "fade-in"}>
      <div style={{
        position: 'absolute',
        top: screens.xs ? 15: 40,
        right: 40,
        zIndex: 100
      }}>
        <MySegmented
          onChange={(value) => handleChangeLangSelect(value)}
          value={lang}
          options={[
          { label: 'ҚАЗ', value: LANG_KEY.KZ },
          { label: 'РУС', value: LANG_KEY.RU },
            ]}
          />
      </div>
      <Flex
        justify="center"
        align='center'
        style={{
          width: 520,
        }}
      >
        <Row justify='center' gutter={[ 16,16]}>
          <Col>
          <Link to={embeddedLink(ROUTE_PATH.MAIN)}>

            <LogoIcon />
            </Link>
          </Col>
          <Col span={24}>
            <RegistrationSteps currentStep={currentStep} />
          </Col>

          <Col>
            <Form form={form} style={{ marginBottom: 0 }}>
              <Row>
                <Col>
                  <Form.Item name={FORM_NAME.email} labelCol={{ span: 24 }} 
                  style={{ marginBottom: 0 }}
                  validateStatus={errors.some((err) => err.field === "confirm_token") ? "error" : ""}
                    help={errors.find((err) => err.field === "confirm_token")?.message}
                    >
                    <MyText color="rgba(76, 76, 77, 1)" size={18} lineHeight={'24px'} weight={600}>
                      {t("confirmCode")}
                    </MyText>
                    <Input
                      style={{ marginTop: 8 }}
                      prefix={<KeyOutlined style={{ color: '#969BAB' , marginRight: 8 }} />}
                      placeholder={t("enterCode")}
                      value={verificationCode}
                      onChange={(e) => setVerificationCode(e.target.value)}
                    />
                    <StyledLink 
                      to="#" 
                      onClick={canResend ? handleResendCode : null}
                      style={{ color: canResend ? '#0000EE' : '#969BAB', cursor: canResend ? 'pointer' : 'not-allowed' }}
                    >
                      {canResend ? t("resendCode") : `${t("resendIn")} ${timer} сек`}
                    </StyledLink>
                  </Form.Item>
                </Col>
                <Col>
                  <MyText size={ 18} lineHeight={'24px'} weight={600} color="rgba(76, 76, 77, 1)">
                  {t("consentTitle")}
                  </MyText>
                  <Col style={{marginTop: 16}}>
                  <MyText size={14} lineHeight={'20px'} color="rgba(76, 76, 77, 1)">
                    1. {t("concent1")}<br />
                    2. {t("concent2")}<br />
                    3. {t("concent3")}
                  </MyText>
                  </Col>

                  <Form.Item name="consent" valuePropName="checked" style={{ marginBottom: 0, marginTop: 8 }}>
                    <StyledCheckbox onChange={(e) => setIsConsentChecked(e.target.checked)}>
                      {t("consentConfirm")}
                    </StyledCheckbox>
                  </Form.Item>
                  <Form.Item name="agreement" valuePropName="checked" style={{ marginBottom: 0 }}>
                    <StyledCheckbox onChange={(e) => setIsAgreementChecked(e.target.checked)}>
                      <Link to={embeddedLink('/user-agreement')} target="_blank" rel="noopener noreferrer">
                        {t("userAgreement1")}
                      </Link> {t("userAgreement2")}
                    </StyledCheckbox>
                  </Form.Item>
                  {/* <Form.Item name="privacy" valuePropName="checked" style={{ marginBottom: 0 }}>
                    <StyledCheckbox onChange={(e) => setIsPrivacyChecked(e.target.checked)}>
                      <Link to='/privacy-policy' target="_blank" rel="noopener noreferrer">
                        {t("withPrivacyPolicy")}
                      </Link>{t("consentConfirm2")}
                    </StyledCheckbox>
                  </Form.Item> */}
                </Col>

                <Col span={24}>
                  <Form.Item style={{ marginBottom: 8, marginTop: 16 }}>
                    <MyButton 
                      type='primary' 
                      htmlType="submit" 
                      color='orange' 
                      style={{ width: '100%' , fontSize: '18px' }} 
                      disabled={!isButtonEnabled()} 
                      onClick={handleUserConfirmation}
                    >
                      {t("continue")} →
                    </MyButton>
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Flex justify="center">
                    <Form.Item>
                      <MyText color='#0A033C' size={ 20} lineHeight={'32px'}>
                        {t("haveAccount")}
                      </MyText>
                      <Link to={embeddedLink("/auth")}>
                        <MyText color="rgba(0, 141, 210, 1)" style={{ marginLeft: 5 }} size={ 20} lineHeight={'32px'}>
                          {t("login")}
                        </MyText>
                      </Link>
                    </Form.Item>
                  </Flex>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Flex>
    </StyledAuth>
  );
}
